import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { PagesServices } from '../../pages.services';
import * as _ from "lodash";
import { MapServices } from '../../map/map.services';


@Component({
  selector: 'dialog-show-map',
  templateUrl: './dialog-show-map.component.html',
  styleUrls: ['./dialog-show-map.component.scss']
})
export class DialogShowMapComponent implements OnInit {
  deviceUsers:any;
  loading: boolean = false;
  loadingMessage: string = "Loading...";
  mapconfig:any;
  map: google.maps.Map = null;
  latitude:number;
  longitude:number;
  zoom: number;

  _this:any;
  data: any;

  device:any;

  previousWindow: any;
  placeId: string = '';
  placeTitle: string = '';
  currentAddress: string[];

  constructor(
    private _pagesServices : PagesServices,
    private _mapServices: MapServices,
    protected ref: NbDialogRef<DialogShowMapComponent>,
  ) {
    this._this = this;
    this.loading = true;
  }

  ngOnInit() {
    if(this.data !== null) {
      this.latitude = this.data.lat;
      this.longitude = this.data.lng;
      this.zoom = 14;
    } else {
      this.latitude = this._pagesServices.mapConfig.latitude;
      this.longitude = this._pagesServices.mapConfig.longitude;
      this.zoom = this._pagesServices.mapConfig.zoom;
    }

    this.AddMapPin();
  }

  ngOnDestroy(){
  }

  onMapLoad(mapInstance: google.maps.Map) {
    this.map = mapInstance;
  }

  AddMapPin() {
    this.deviceUsers = this._pagesServices.deviceUsers.filter(q => q.user_type == 'DEVICE');
    this.device = this.deviceUsers.filter(q => q.id === this.data.user_id)[0];
    if(this.device ) {
      if(this.device.marker){
        this.device.marker.lat = this.data.lat;
        this.device.marker.lng = this.data.lng;
        console.log(`testtttt`)
      } else {
        this.device.marker = {
          device: this.device.username,
          lat: this.data.lat,
          lng: this.data.lng,
          imgPin: this.device.photo + "#custom_marker",
          stopautopan: true,
          created: this.data.created
        };
      }
    }
  }

  close() {
    this.ref.close();
  }

  GetPinItem() {
    if(this.device != null) {
      return this.device;
    } else return null;
  }

  clickedMarker(data) {
    if(this.previousWindow) {
      this.previousWindow.close();
    }

    this.previousWindow = data;

    const lat = parseFloat(data.latitude);
    const lng = parseFloat(data.longitude);
    const latlngData = {
      lat: lat,
      lng: lng
    }

    if(data) { 
      this.currentAddress = ["Loading..."];

      this._mapServices.GetLocationAddress(latlngData).subscribe(res => {
        
        if(!res.address) {
          this.placeId = '';
          this.placeTitle = '';
          this.currentAddress = ["Address not available."];
          return;
        }

        let address = res.address.split(',').map(a => a.trim(0,5));
        this.placeId = res.placeId;
        this.placeTitle = address[0];
        this.currentAddress = address.slice(1);

      }, () => {
        this.placeId = '';
        this.placeTitle = '';
        this.currentAddress = ["Address not available."];
      });
    }
  }

}
